import { render, staticRenderFns } from "./TrGameBody.vue?vue&type=template&id=99c07748&"
import script from "./TrGameBody.vue?vue&type=script&lang=js&"
export * from "./TrGameBody.vue?vue&type=script&lang=js&"
import style0 from "./TrGameBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports